// react
import React, { useState } from "react";

// react-router-dom
import { useNavigate } from "react-router-dom";

// context
import { UserAuth } from "context/AuthContext";

// react-i18next
import { useTranslation } from "react-i18next";

// @mui
import { Container, Box, Grid, TextField, Button, Typography } from "@mui/material";

// components
import { ResetPasswordDialog } from "components/app/AppFeedback";
import Copyright from "components/layout/Copyright";

// A ---------------------------------------------------------------------- M

const PasswordResetRequestPage = () => {
  const { resetPassword } = UserAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [openReset, setOpenReset] = useState(false);

  const handleReset = async () => {
    await resetPassword(email);
    setOpenReset(true);
  };

  const handleCloseReset = () => {
    setOpenReset(false);
    navigate("/signin");
  };

  return (
    <>
      <Box
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Container
          component="main"
          maxWidth="sm"
          sx={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              bgcolor: "rgba(255, 255, 255, 0.8)",
              backdropFilter: "blur(5px)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              width: "100%",
            }}
          >
            <Typography variant="h5" fontWeight="bold" mb={3} align="center">
              {t("email")}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField variant="outlined" fullWidth required id="email" label={t("email")} name="email" value={email} onChange={(e) => setEmail(e.target.value)} aria-label={t("email")} />
              </Grid>
              <Grid item xs={12}>
                <Button fullWidth variant="contained" color="primary" onClick={handleReset} aria-label={t("reset_password")} disabled={!email} sx={{ py: 2, borderRadius: 3 }}>
                  {t("reset_password")}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <Box sx={{ mt: 2, pb: 2 }}>
          <Copyright />
        </Box>
      </Box>
      {openReset && <ResetPasswordDialog open={openReset} handleClose={handleCloseReset} />}
    </>
  );
};

export default PasswordResetRequestPage;
